export default {
    address: {
        city: 'city',
        state: 'tx'
    },
    favourite: true,
    id: '',
    mi_enabled: true,
    name: 'somename',
    status: true,
    external_reference: {
        tlr: '{"billingPrice":646.92,"nextBillingDate":"2021-03-20T00:22:48Z","isActive"' +
                ':true,"message":null,"subscriptionTypes":["TLR_AP"],"subscriptionId":' +
                '"6149721813946998004004","additionalUsers":15,"discount":10.0,"numberOfTrialDays":14.0}'
    }
};
